export enum LocalStorageType {
    FinalWeekMode = `irc-finalweekmode`
}